import { useGlobals } from "@/hooks";
import { useClient } from "@/hooks";
import { useCorporateFlags } from "@/hooks";
import { useMemo } from "react";
import { getSegmentCode } from "@/shared";

export const usePayments = () => {
  const { paymentCode } = useGlobals();
  const { selectedClient } = useClient();
  const { selectedBrandPair } = useCorporateFlags();

  const clientPayments = useMemo(() => {
    const pair = selectedBrandPair;
    const lojas = Array.isArray(selectedClient?.lojas) ? selectedClient.lojas : [];

    if (
      pair != null &&
      Number.isFinite(Number(pair.codLoja)) &&
      Number.isFinite(Number(pair.codSegmento)) &&
      lojas.length > 0
    ) {
      const codLoja = Number(pair.codLoja);
      const codSegmento = Number(pair.codSegmento);

      const matchedLoja = lojas.find((loja: any) => {
        if (Number(loja?.COD_LOJA) !== codLoja) return false;
        const segmentos = Array.isArray(loja?.COD_SEGMENTO) ? loja.COD_SEGMENTO : [];
        return segmentos.some((s: any) => getSegmentCode(s) === codSegmento);
      });

      const pay = matchedLoja?.COD_PAGAMENTO;
      if (Array.isArray(pay) && pay.length > 0) {
        return [...pay].sort((a, b) => a.cod_condicao - b.cod_condicao);
      }
    }

    return [];
  }, [selectedBrandPair, selectedClient?.lojas]);

  const currentPayment = useMemo(() => {
    return clientPayments?.find(({ cod_condicao }) => cod_condicao === paymentCode)?.desc_condicao;
  }, [clientPayments, paymentCode]);

  return {
    clientPayments,
    currentPayment,
  };
};
